import React, { Fragment } from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import useWindowSize from '../../hooks/useWindowSize'
import VoidPage from '../VoidPage'
import texts from '../../common/texts.json'
import { getTenant } from '../../Helpers'
import PropTypes from 'prop-types'

const VoidPDP = ({ sku }) => {
  const { VOID_PLP, VOID_PDP, COMMON } = texts
  const categories = useSelector((state) => state.campaignConfigReducer.categoriesSliderMenuHeader)
  const { isMobile } = useWindowSize()
  const tenant = getTenant()
  const { host, protocol } = window.location
  window.location.replace(`${protocol}//${host}/${tenant}/product/sku/${sku}/not-found`)

  const message = () => (
    <Fragment>
      {VOID_PLP.TEXT[0]}
      {COMMON.SPACE}
      <Link to="/">{VOID_PLP.TEXT[1]}</Link>
      {COMMON.SPACE}
      {VOID_PLP.TEXT[2]}
    </Fragment>
  )
  return (
    <div className="void-pdp">
      <VoidPage
        title={VOID_PLP.TITLE}
        subtitle={VOID_PDP.SUBTITLE}
        message={message()}
        isMobile={isMobile}
        categories={categories}
        relatedProduct={[]}
      />
    </div>
  )
}
VoidPDP.propTypes = {
  sku: PropTypes.number,
}

export default VoidPDP
